import mongoose from 'mongoose'
    import config from '../config.json';
    import bcrypt from 'bcrypt-nodejs';
    import jwt from 'jsonwebtoken';
    import Mailgun from 'mailgun-js';
    
    export const userSchema = mongoose.Schema({
        email:{
            type:String,
            required:true,
            unique:true ,
        },
        password:{
            type:String,
            required:true,
        },
        username:{
            type:String,
            required:true,
            unique:true
        },
        active:{
            type:Boolean,
            default:false
        }
    });
    const mailgun = Mailgun({apiKey:config.mailgun_key,
        domain: config.mailgun_domain});
    userSchema.statics = {
        register:async function register(data){
          data.password = bcrypt.hashSync(data.password);
           const  user = new User(data);
           const savedData =  await user.save();
           const token = jwt.sign({_id:user._id,type:'activation link'},
            config.secret,{ expiresIn: 60*60*24*7 } );
           const msg = {
            from: config.system_auth_mail,
            to: user.email,
            subject: 'activate your account',
            text: 'please activate you account '
        };
        mailgun.messages().send(msg, function (err, body) {
            if(err) console.log(err);
        });
        return savedData
         },
           emailLogin:async(data)=>{
             var user = await User.findOne({email:data.email}).exec();
             if(user.validatePassword(data.password)){
               var Token = jwt.sign({_id:user._id},
                             config.secret,{ expiresIn: 60*60*24*7 })
                return{token:Token,username:user.username,email:user.email,id:user._id}
             }else{
              throw new Error("user not found")
             }
    
           },
    
        usernameLogin:async(data)=>{
          var user = await User.findOne({username:data.username}).exec();
          if(user.validatePassword(data.password)){
            var Token = jwt.sign({_id:user._id},
                          config.secret,{ expiresIn: 60*60*24*7 })
             return{token:Token,username:user.username,email:user.email,id:user._id}
          }else{
             throw new Error("user not found")
          }
    
    
    
        }
    };
    userSchema.methods={
        validatePassword: function(password) {
          var d = bcrypt.compareSync(password, this.password);
    
            return d
    
        },
        sendActivationEmail:function () {
            var token = jwt.sign({_id:this._id,type:'activation link'},
                config.secret,{ expiresIn: 60*60*24*7 } );
    
            var data = {
                from: config.system_auth_mail,
                to: this.email,
                subject: 'activate your account',
                text: "please activate you account "
            };
            mailgun.messages().send(data, function (err, body) {
                if(err)throw err
            });
        }
    };
    const User = mongoose.model("User",userSchema);
    export default User
    